import type { Dict } from '../index.js';

/** Arabic: people. Keys are the exact English text. */
export const people: Dict = {
  // ── Employees list ──
  'My Team': 'فريقي',
  'Employees': 'الموظفون',
  'Employees who report to you': 'الموظفون التابعون لك',
  'Everyone in the company, across all countries': 'جميع موظفي الشركة في كل الدول',
  'Add employee': 'إضافة موظف',
  'Search name, ID, e-mail, position, city…': 'ابحث بالاسم أو الرقم الوظيفي أو البريد أو المسمى أو المدينة…',
  'Department': 'القسم',
  'All departments': 'كل الأقسام',
  'Country': 'الدولة',
  'All countries': 'كل الدول',
  'Status': 'الحالة',
  'Any status': 'أي حالة',
  'Work arrangement': 'نمط العمل',
  'Office & remote': 'المكتب وعن بُعد',
  'Include deactivated employees': 'تضمين الموظفين الموقوفين',
  'No employees found': 'لم يتم العثور على موظفين',
  'Try clearing the filters.': 'جرّب مسح عوامل التصفية.',
  'Add your first employee to get started.': 'أضف أول موظف للبدء.',
  'Nobody is assigned to you yet.': 'لا يوجد موظفون تابعون لك بعد.',
  'Employee': 'موظف',
  'Department / Position': 'القسم / المسمى الوظيفي',
  'Location & time zone': 'الموقع والمنطقة الزمنية',
  'Manager': 'المدير',
  'Login': 'الدخول',
  'No login': 'بلا حساب دخول',

  // ── Roles (values shown as badges) ──
  admin: 'مسؤول النظام',
  manager: 'مدير',
  employee: 'موظف',

  // ── Enum labels rendered in these pages ──
  'Full-time': 'دوام كامل',
  'Part-time': 'دوام جزئي',
  'Contractor': 'متعاقد',
  'Intern': 'متدرب',
  'Temporary': 'مؤقت',
  'Active': 'نشط',
  'Probation': 'فترة تجربة',
  'Suspended': 'موقوف مؤقتًا',
  'Terminated': 'منتهية خدمته',
  'Office': 'المكتب',
  'Remote': 'عن بُعد',
  'Hybrid': 'مختلط',

  // ── Employee detail ──
  'Local time {time} · {zone} ({offset})': 'التوقيت المحلي {time} · {zone} ({offset})',
  'Back to employees': 'العودة إلى الموظفين',
  'Overview': 'نظرة عامة',
  'Leave': 'الإجازات',
  'Schedule & time zone': 'جدول العمل والمنطقة الزمنية',
  'Salary': 'الراتب',
  'Login account': 'حساب الدخول',
  'Activity': 'النشاط',
  'No position': 'بلا مسمى وظيفي',
  'Attendance →': 'الحضور ←',
  'Edit': 'تعديل',
  'Deactivate': 'إيقاف',
  'Reactivate': 'إعادة تفعيل',
  'Delete': 'حذف',
  'Deactivated on {date} (last working day {endDate}). Their login is disabled; history is kept.':
    'تم الإيقاف في {date} (آخر يوم عمل {endDate}). حساب الدخول معطَّل، والسجل محفوظ.',
  'Deactivate {name}?': 'إيقاف {name}؟',
  'The employee is marked as terminated, their login is disabled and all their sessions end immediately. All history is kept, and they can be reactivated later.':
    'سيُعلَّم الموظف كمنتهية خدمته، ويُعطَّل حساب دخوله وتنتهي جميع جلساته فورًا. يُحفظ السجل كاملًا ويمكن إعادة تفعيله لاحقًا.',
  'Last working day': 'آخر يوم عمل',
  'Reactivate {name}?': 'إعادة تفعيل {name}؟',
  'The employee becomes active again. Their login stays disabled until you enable it on the Login account tab.':
    'سيعود الموظف نشطًا. يبقى حساب الدخول معطَّلًا حتى تفعّله من تبويب حساب الدخول.',
  'Permanently delete {name}?': 'حذف {name} نهائيًا؟',
  'Only use this for records created by mistake. Employees with a login account, reports or any history cannot be deleted — deactivate them instead.':
    'استخدم هذا فقط للسجلات المُنشأة بالخطأ. لا يمكن حذف موظف لديه حساب دخول أو تقارير أو أي سجل — أوقفه بدلًا من ذلك.',
  'Delete permanently': 'حذف نهائي',
  'Profile': 'الملف الشخصي',
  'E-mail': 'البريد الإلكتروني',
  'Phone': 'الهاتف',
  'City': 'المدينة',
  'Position': 'المسمى الوظيفي',
  'Employment type': 'نوع التوظيف',
  'Start date': 'تاريخ البدء',
  'End date': 'تاريخ الانتهاء',
  'Can approve leave': 'يمكنه الموافقة على الإجازات',
  'Yes (for their team)': 'نعم (لفريقه)',
  'No': 'لا',
  'Yes': 'نعم',
  'Time zone': 'المنطقة الزمنية',
  'Work schedule': 'جدول العمل',
  'Holidays: {name}': 'العطلات: {name}',
  'None': 'لا يوجد',
  'Since {date}': 'منذ {date}',
  'No terms in effect yet.': 'لا توجد شروط عمل سارية بعد.',
  'Direct reports ({n})': 'المرؤوسون المباشرون ({n})',
  'Leave policy': 'سياسة الإجازات',
  'None assigned': 'غير محددة',
  'Balances and requests are on the Leave tab.': 'الأرصدة والطلبات في تبويب الإجازات.',
  'Terms history': 'سجل شروط العمل',
  'Schedule a change': 'جدولة تغيير',
  'Effective from': 'ساري من',
  'Holiday calendar': 'تقويم العطلات',
  'Recorded': 'تاريخ التسجيل',
  'Current': 'الحالي',
  'Scheduled': 'مجدول',
  'by {name}': 'بواسطة {name}',
  'Remove': 'إزالة',
  'Current schedule: {name}': 'الجدول الحالي: {name}',
  'Schedule a work-terms change': 'جدولة تغيير في شروط العمل',
  'Cancel': 'إلغاء',
  'Save change': 'حفظ التغيير',
  'A change never edits past days: it applies from the effective date onward. Use a future date for planned changes (e.g. relocation).':
    'التغيير لا يعدّل الأيام السابقة، بل يسري من تاريخ السريان فصاعدًا. استخدم تاريخًا مستقبليًا للتغييرات المخطط لها (مثل الانتقال).',
  'This date is in the past. A reason is required and the change is flagged as retroactive in the audit log.':
    'هذا التاريخ في الماضي. يلزم ذكر السبب، وسيُعلَّم التغيير كأثر رجعي في سجل التدقيق.',
  'Applies to leave years created after this date; existing balances are not changed.':
    'تُطبَّق على سنوات الإجازات التي تُنشأ بعد هذا التاريخ، ولا تتغير الأرصدة الحالية.',
  'Reason': 'السبب',
  'Reason (optional)': 'السبب (اختياري)',
  'Remove scheduled change?': 'إزالة التغيير المجدول؟',
  'This change has not taken effect yet, so removing it does not affect any past records.':
    'هذا التغيير لم يسرِ بعد، لذا لن تؤثر إزالته على أي سجلات سابقة.',
  '{n}m break': 'استراحة {n} د',
  'Off': 'عطلة',
  Mon: 'الإثنين',
  Tue: 'الثلاثاء',
  Wed: 'الأربعاء',
  Thu: 'الخميس',
  Fri: 'الجمعة',
  Sat: 'السبت',
  Sun: 'الأحد',
  'No login account': 'لا يوجد حساب دخول',
  'Create a login so this employee can sign in, see their leave and attendance.':
    'أنشئ حساب دخول ليتمكن هذا الموظف من تسجيل الدخول والاطلاع على إجازاته وحضوره.',
  'Reactivate the employee first.': 'أعد تفعيل الموظف أولًا.',
  'Role': 'الدور',
  'Administrator': 'مسؤول النظام',
  'Create login': 'إنشاء حساب دخول',
  'Login created': 'تم إنشاء حساب الدخول',
  'Done': 'تم',
  'Account': 'الحساب',
  'Sign-in e-mail': 'بريد تسجيل الدخول',
  'Enabled': 'مفعَّل',
  'Disabled': 'معطَّل',
  'Last sign-in': 'آخر تسجيل دخول',
  'Never': 'أبدًا',
  'Locked': 'مقفل',
  'Until {time}': 'حتى {time}',
  'Must change password': 'يجب تغيير كلمة المرور',
  'Reset password': 'إعادة تعيين كلمة المرور',
  'Disable login': 'تعطيل الدخول',
  'Enable login': 'تفعيل الدخول',
  'Employee — own data only': 'موظف — بياناته فقط',
  'Manager — their team': 'مدير — فريقه',
  'Administrator — everything': 'مسؤول النظام — كل شيء',
  'Save role': 'حفظ الدور',
  'Changing the role signs the user out so their new permissions apply immediately.':
    'تغيير الدور يسجّل خروج المستخدم لتُطبَّق صلاحياته الجديدة فورًا.',
  'Can see salaries & payroll': 'يمكنه رؤية الرواتب',
  'Turn off to give this administrator everything except salaries (Payroll page, Salary tab and salary figures in the audit log).':
    'أوقفه لمنح مسؤول النظام هذا كل الصلاحيات عدا الرواتب (صفحة الرواتب وتبويب الراتب وأرقام الرواتب في سجل التدقيق).',
  'New temporary password': 'كلمة مرور مؤقتة جديدة',
  'Reset password?': 'إعادة تعيين كلمة المرور؟',
  'A new temporary password is generated, the user is signed out everywhere and must choose a new password at next sign-in.':
    'ستُنشأ كلمة مرور مؤقتة جديدة، ويُسجَّل خروج المستخدم من كل الأجهزة، وعليه اختيار كلمة مرور جديدة عند تسجيل الدخول التالي.',
  'Disable login?': 'تعطيل الدخول؟',
  'The user is signed out immediately and cannot sign in until the login is enabled again.':
    'سيُسجَّل خروج المستخدم فورًا ولن يتمكن من الدخول حتى يُعاد تفعيل حسابه.',
  'Disable': 'تعطيل',
  'No activity yet': 'لا يوجد نشاط بعد',
  'Reason: {reason}': 'السبب: {reason}',
  'Salary details hidden (no payroll access)': 'تفاصيل الراتب مخفية (لا توجد صلاحية للرواتب)',
  'Leave requests': 'طلبات الإجازة',

  // ── Audit field names (ChangeSummary) ──
  'Full name': 'الاسم الكامل',
  'Employee ID': 'الرقم الوظيفي',
  'Employment status': 'حالة التوظيف',
  'Fingerprint machine ID': 'رقم جهاز البصمة',
  'Working hours are tracked': 'ساعات العمل مسجَّلة',
  'Daily worked-time rule': 'قاعدة احتساب ساعات العمل اليومية',
  'Hours come from': 'مصدر الساعات',
  'The desktop agent records': 'يسجّل برنامج سطح المكتب',
  'Work terms': 'شروط العمل',
  'Login disabled': 'الدخول معطَّل',
  'Note': 'ملاحظة',
  'Name': 'الاسم',
  'Description': 'الوصف',
  'Date': 'التاريخ',
  'Half day': 'نصف يوم',
  'Year': 'السنة',
  'Added': 'أُضيف',
  'Removed': 'أُزيل',
  'Late arrival grace (minutes)': 'مهلة التأخير (بالدقائق)',
  'Early departure grace (minutes)': 'مهلة الانصراف المبكر (بالدقائق)',
  'Working days': 'أيام العمل',
  'Currency': 'العملة',
  'Amount': 'المبلغ',
  'Period': 'الفترة',

  // ── Employee form ──
  'Please fix the highlighted fields': 'يرجى تصحيح الحقول المحددة',
  'Back': 'رجوع',
  'Edit {name}': 'تعديل {name}',
  'Edit employee': 'تعديل موظف',
  'Personal & contact': 'البيانات الشخصية والتواصل',
  'Your internal ID, e.g. EMP-012': 'الرقم الداخلي، مثل EMP-012',
  'Also used to sign in': 'يُستخدم أيضًا لتسجيل الدخول',
  'Job': 'الوظيفة',
  'No department': 'بلا قسم',
  'Manager / supervisor': 'المدير / المشرف',
  'No manager': 'بلا مدير',
  'Employment start date': 'تاريخ بدء التوظيف',
  'Controls who may use the app Clock-in button (Settings → Attendance). Remote staff can instead be paid on computer hours (below).':
    'يحدد من يمكنه استخدام زر تسجيل الحضور في التطبيق (الإعدادات ← الحضور). ويمكن بدلًا من ذلك احتساب رواتب الموظفين عن بُعد على ساعات الكمبيوتر (أدناه).',
  'e.g. Cairo office': 'مثل: مكتب القاهرة',
  'The user number enrolled on the office fingerprint machine. Leave empty to match by employee ID.':
    'رقم المستخدم المسجَّل على جهاز البصمة في المكتب. اتركه فارغًا للمطابقة بالرقم الوظيفي.',
  'Contract end date': 'تاريخ انتهاء العقد',
  'Leave empty for open-ended employment': 'اتركه فارغًا للتوظيف غير محدد المدة',
  'Can approve leave for their team': 'يمكنه الموافقة على إجازات فريقه',
  'Managers can review requests from employees who report to them only if this is on.':
    'لا يستطيع المدير مراجعة طلبات الموظفين التابعين له إلا إذا كان هذا الخيار مفعَّلًا.',
  'Turn off for people whose hours are not recorded (e.g. the owner). Their days show as “Not tracked” instead of “Absent” and payroll pays the fixed salary.':
    'أوقفه للأشخاص الذين لا تُسجَّل ساعاتهم (مثل المالك). تظهر أيامهم «غير مسجَّلة» بدلًا من «غائب»، وتصرف الرواتب الراتب الثابت.',
  'Clock in / out (fingerprint, door QR, app)': 'تسجيل الحضور / الانصراف (البصمة، رمز QR على الباب، التطبيق)',
  'Computer activity — desktop agent, no clocking in': 'نشاط الكمبيوتر — برنامج سطح المكتب، دون تسجيل حضور',
  'For remote staff paid on computer hours, “whenever in use” is the default.':
    'للموظفين عن بُعد الذين تُحتسب رواتبهم على ساعات الكمبيوتر، يكون «كلما كان قيد الاستخدام» هو الافتراضي.',
  'Whenever the computer is in use (default)': 'كلما كان الكمبيوتر قيد الاستخدام (افتراضي)',
  'As in company settings': 'حسب إعدادات الشركة',
  'Only while clocked in': 'فقط أثناء تسجيل الحضور',
  'During scheduled working hours': 'خلال ساعات العمل المجدولة',
  'Whenever the computer is in use': 'كلما كان الكمبيوتر قيد الاستخدام',
  "Worked time = computer activity as set in Settings → Attendance (“Hours from computer activity count”; default: time in use, idle excluded). First and last activity replace clock-in and clock-out. Payroll, overtime and missing hours use these hours. The employee's notice tells them this before anything is recorded.":
    'ساعات العمل = نشاط الكمبيوتر كما هو محدد في الإعدادات ← الحضور («طريقة احتساب ساعات نشاط الكمبيوتر»؛ الافتراضي: وقت الاستخدام دون وقت الخمول). أول وآخر نشاط يحلّان محل تسجيل الحضور والانصراف. تعتمد الرواتب والعمل الإضافي والساعات الناقصة على هذه الساعات. ويُبلَّغ الموظف بذلك في إشعار الخصوصية قبل تسجيل أي شيء.',
  'Schedule, time zone & holidays': 'جدول العمل والمنطقة الزمنية والعطلات',
  'These settings drive leave and attendance calculations. They are effective-dated: later changes are made from the employee page with an effective date, so past periods keep the rules that applied at the time.':
    'تعتمد حسابات الإجازات والحضور على هذه الإعدادات. وهي مرتبطة بتاريخ سريان: تُجرى التغييرات لاحقًا من صفحة الموظف مع تاريخ سريان، فتحتفظ الفترات السابقة بالقواعد التي كانت سارية حينها.',
  'IANA time zone — handles daylight saving automatically.': 'منطقة زمنية IANA — تراعي التوقيت الصيفي تلقائيًا.',
  '{duration} per week': '{duration} أسبوعيًا',
  'Select schedule…': 'اختر جدول العمل…',
  'Public holiday calendar': 'تقويم العطلات الرسمية',
  'No holiday calendar': 'بلا تقويم عطلات',
  'Sets the yearly allowances (e.g. 21 vacation days). Individual allowances can be changed later on the Vacation Balances page.':
    'تحدد الاستحقاقات السنوية (مثل 21 يوم إجازة). يمكن تعديل الاستحقاقات الفردية لاحقًا من صفحة أرصدة الإجازات.',
  'No leave policy': 'بلا سياسة إجازات',
  'Create a login for this employee': 'إنشاء حساب دخول لهذا الموظف',
  'A temporary password is generated and shown once. The employee must change it at first sign-in.':
    'تُنشأ كلمة مرور مؤقتة وتُعرض مرة واحدة. يجب على الموظف تغييرها عند أول تسجيل دخول.',
  'Reason for change (optional)': 'سبب التغيير (اختياري)',
  'Recorded in the audit log': 'يُسجَّل في سجل التدقيق',
  'Save changes': 'حفظ التغييرات',
  'Create employee': 'إنشاء الموظف',
  'Employee created': 'تم إنشاء الموظف',
  'Open employee': 'فتح ملف الموظف',
  '{name} was added.': 'تمت إضافة {name}.',
  'Temporary password for {name}.': 'كلمة المرور المؤقتة لـ {name}.',
  'It is shown only once — share it with the employee through a secure channel.':
    'تُعرض مرة واحدة فقط — شاركها مع الموظف عبر وسيلة آمنة.',
  'Copied': 'تم النسخ',
  'Copy': 'نسخ',
  'They will be asked to choose their own password at first sign-in.': 'سيُطلب منه اختيار كلمة مرور خاصة به عند أول تسجيل دخول.',

  // ── Departments ──
  'Departments': 'الأقسام',
  'Organise employees into teams': 'نظّم الموظفين في فرق',
  'Add department': 'إضافة قسم',
  'No departments yet': 'لا توجد أقسام بعد',
  'Head': 'رئيس القسم',
  'Active employees': 'الموظفون النشطون',
  'Inactive': 'غير نشط',
  'Edit department': 'تعديل القسم',
  'Save': 'حفظ',
  'Department head': 'رئيس القسم',
  "Inactive departments can't be chosen for new employees.": 'لا يمكن اختيار الأقسام غير النشطة للموظفين الجدد.',
  'Delete {name}?': 'حذف {name}؟',
  "Departments that have (or had) employees can't be deleted — deactivate them instead.":
    'لا يمكن حذف الأقسام التي بها (أو كان بها) موظفون — أوقفها بدلًا من ذلك.',

  // ── Profile ──
  'Signed in as {email} (administrator account, not linked to an employee record).':
    'مسجَّل الدخول باسم {email} (حساب مسؤول نظام غير مرتبط بسجل موظف).',
  'My profile': 'ملفي الشخصي',
  'Your details as held by the company. Ask an administrator to correct anything.':
    'بياناتك كما هي مسجلة لدى الشركة. اطلب من مسؤول النظام تصحيح أي شيء.',
  'Location': 'الموقع',
  'Change password': 'تغيير كلمة المرور',

  // ── Audit log ──
  'Audit log': 'سجل التدقيق',
  'Append-only record of every important action. Entries cannot be edited or deleted.':
    'سجل تراكمي لكل إجراء مهم. لا يمكن تعديل الإدخالات أو حذفها.',
  'Verify integrity': 'التحقق من السلامة',
  'Hash chain intact — {n} entries verified. No entry has been altered or removed.':
    'سلسلة التجزئة سليمة — تم التحقق من {n} إدخال. لم يُعدَّل أو يُحذف أي إدخال.',
  'Integrity check FAILED at entry #{id}. The log has been modified outside the application.':
    'فشل التحقق من السلامة عند الإدخال رقم {id}. تم تعديل السجل من خارج التطبيق.',
  'Action': 'الإجراء',
  'Done by': 'نفّذه',
  'e-mail': 'البريد الإلكتروني',
  'From': 'من',
  'To': 'إلى',
  'No entries match': 'لا توجد إدخالات مطابقة',
  'deleted employee': 'موظف محذوف',
  'All actions': 'كل الإجراءات',
  'Sign-ins': 'تسجيلات الدخول',
  'Employee changes': 'تغييرات الموظفين',
  'Login accounts': 'حسابات الدخول',
  'Leave requests & balances': 'طلبات الإجازة والأرصدة',
  'Leave types & policies': 'أنواع الإجازات والسياسات',
  'Settings': 'الإعدادات',
  'Schedules': 'جداول العمل',
  'Holidays': 'العطلات',
  'Official holiday syncs': 'مزامنة العطلات الرسمية',

  // ── Country select ──
  'Select country…': 'اختر الدولة…',

  // ── Pay calculation ──
  'Pay calculation': 'طريقة حساب الأجر',
  'How payroll works out this person’s salary.': 'كيف يحسب النظام أجر هذا الشخص.',
  'Standard — full salary for the required hours, less a share for any missing hours':
    'عادي — الراتب كامل مقابل الساعات المطلوبة، مع خصم نسبة عن أي ساعات ناقصة',
  'Always full salary — never reduced for hours (e.g. a manager)':
    'الراتب كامل دائمًا — لا يُخصم منه مقابل الساعات (مثل المدير)',
  'Per hour — paid only for the hours worked (e.g. casual / short-term)':
    'بالساعة — يُدفع فقط مقابل الساعات المُنجزة (مثل العمل المؤقت)',
};
